<template>
  <div class="flex flex-col items-center justify-center flex-1 px-6 py-14 sm:px-14">
    <slot name="icon">
      <span class="i-heroicons-circle-stack text-slate-500 size-8"></span>
    </slot>
    <slot name="title">
      <h2 class="text-lg font-semibold text-center text-slate-900">No records found</h2>
    </slot>
    <slot name="description">
      <p class="text-sm text-center text-slate-500 pt-4">
        There are no records to display at the moment.
      </p>
    </slot>
    <slot name="footer">
    </slot>
  </div>
</template>